import React, {useState} from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { countActions } from '../../store/count';
import { authActions } from '../../store/auth';
import { useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import  Tooltip  from '@mui/material/Tooltip';
import FormControlLabel  from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { es } from "date-fns/locale";
import isValidImgExtentision from '../../data/isValidImageExtension';
import { NoteImageSize } from './NoteImageSize';

  
const Input = styled('input')({
  display: 'none',
});

const CreateForm = props => {

  const formatDate = (date = new Date()) => {
    return [
      `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`
    ]
  }

  const username = useSelector( state => state.auth.username );
  const token = useSelector (state => state.auth.token )
  const [titulo, setTitulo] = useState('');
  const [contenido, setContenido ] = useState('');  
  const [descripcion, setDescripcion] = useState('');
  const [fecha, setFecha ] = useState(new Date());
  const [checked, setChecked ] = useState(false);
  const [file, setFile] = useState([]);

  const [Isdone, setIsDone] = useState(false);
  const [isError, setError] = useState(false);
  const [isSaved, setSaved] = useState(false);

  const dispatch = useDispatch();

    const type = useSelector( state => state.type.typeIs );

      const handleSubmitPlan = e => {
        e.preventDefault();
        setIsDone(true);
        const options = {
          headers: {
            'authorization':  `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        }
        const form = new FormData();
        form.append('descripcion', descripcion);
        form.append('fecha', formatDate(fecha));
        form.append('files', file);
        form.append('usuario', username);
        form.append('activo', checked);
  
        axios.post('api/crearPlanAtraque', form, options).then( res =>{
            setSaved(true); 
            setIsDone(true);  
            setError(false) 
            dispatch(countActions.count()); 
            
        }).catch( e => {
          if(e.response.status === 401) {
            dispatch(authActions.logout());
          }
          setIsDone(false);
          setError(true);
        })
      }

      const handleSubmitNews = e => {
        e.preventDefault();
        setIsDone(true);
      const options = {
        headers: {
          'authorization':  `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      }
      const form = new FormData();
      form.append('titulo', titulo);
      form.append('contenido', contenido);
      form.append('files', file);
      form.append('usuario', username);
      form.append('activo', checked);

      axios.post('api/crearNoticia', form, options).then( res =>{
        setSaved(true);
        setIsDone(true); 
        setError(false)
        dispatch(countActions.count()); 
      }).catch( e => {
        if(e.response.status === 401) {
          dispatch(authActions.logout());
        }
        setError(true)
        setIsDone(false);
      })
      }

      const handleClose = e => {
        props.closeModal();
      }

    if (type === 'plan'){
      return (

        <>
          <Box m={2}>
          <Box 
            display="flex"
            justifyContent="flex-end"
            alignItems="flex-end">
              <Tooltip title="Cerrar">
                <Button onClick={handleClose}><CloseIcon/></Button>
            </Tooltip>
          </Box>
          <Typography id="modal-modal-title" variant="h6" component="h2">
          Crear Formato
          </Typography>
          </Box>
          <Box component="form" Validate onSubmit={handleSubmitPlan} sx={{ mt: 1 }}>
        <TextField
           sx={{ mb: 3}}
          margin="normal"
          required
          fullWidth
          id="Descripcion"
          label="Descripcion"
          name="Descripcion"
          inputProps={{maxlength: 80 }}
          autoFocus
          value={descripcion}
          onChange={ e => setDescripcion(e.target.value)}
        />
       <LocalizationProvider LocalizationProvider={es} dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Fecha Publicacion"
            value={fecha}
            onChange={(nuevaFecha) => {
              setFecha(nuevaFecha);
            }}
            renderInput={(params) => <TextField fullWidth required {...params} />}
          />
        </LocalizationProvider>
        <FormControlLabel
          control={<Checkbox  
            name='checkbox'
            color="primary"
            checked={checked}
            onChange={ e => setChecked(e.target.checked)}
            />}
          label="Activo"
        />

        <label htmlFor="contained-button-file">
                      <Input required id="contained-button-file" type="file" onChange={(e) => {
                          if (e.target.files[0].size > 100000000) {
                              alert("Archivo no puede exceder los 100 MB");
                              this.value = "";
                          } else {
                              setFile(e.target.files[0])
                          }; 
                      }} />
        <Button fullWidth variant="outlined" component="span">
          Agregar Adjunto
        </Button>
      </label>
        <Button
           disabled={Isdone}
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          Crear
        </Button>
        { isError === true ? <Alert severity="error">Hubo un error al crear</Alert> : null}
        { isSaved === true ? <Alert severity="success">Se ha creado existosamente</Alert> : null}
      </Box>
           
    
            </>

      );
    }
    if (type === 'news') {
      return(
        <>
         <Box m={2}>
         <Box 
            display="flex"
            justifyContent="flex-end"
            alignItems="flex-end">
              <Tooltip title="Cerrar">
                <Button onClick={handleClose}><CloseIcon/></Button>
            </Tooltip>
          </Box>
          <Typography id="modal-modal-title" variant="h6" component="h2">
          Crear Noticia
         </Typography>
         </Box>
         <Box component="form" Validate onSubmit={handleSubmitNews} sx={{ mt: 1 }}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="Titulo"
          label="Titulo"
          name="Titulo"
          inputProps={{maxlength: 250 }}
          autoFocus
          value={titulo}
          onChange={ e => setTitulo(e.target.value)}
          multiline
          rows={2}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="Contenido"
          label="Contenido"
          type="Contenido"
          id="Contenido"
          value={contenido}
          onChange={ e => setContenido(e.target.value)}
          multiline
          rows={10}
        />
        <FormControlLabel
          control={<Checkbox  
            name='checkbox'
            color="primary"
            checked={checked}
            onChange={ e => setChecked(e.target.checked)}
            />}
          label="Activo"
        />
        <label htmlFor="contained-button-file">
                      <Input required id="contained-button-file" accept="image/png, image/jpg, image/jpeg" type="file" onChange={(e) => {
                          if (!isValidImgExtentision(e.target.files[0].type)) {
                            this.value = "";
                            return;
                          }
                          if (e.target.files[0].size > 2000000) {
                              alert("Archivo no puede exceder los 2 MB");
                              this.value = "";
                          } else {
                              setFile(e.target.files[0])
                          };
                      }} />
        <Button fullWidth variant="outlined" component="span">
          Agregar Adjunto
        </Button>
      </label>
      <NoteImageSize />
        <Button
          disabled={Isdone}
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          Crear Noticia
        </Button>
        { isError === true ? <Alert severity="error">Hubo un error al crear</Alert> : null}
        { isSaved === true ? <Alert severity="success">Se ha creado existosamente</Alert> : null}
      </Box>
         </>
      )
      }

}

export default CreateForm;